import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="relative mt-auto">
      <div className="backdrop-blur-2xl border-t border-primary/50 bg-gradient-to-r from-primary to-primary-hover">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            {/* ロゴ・運営情報 */}
            <div className="flex items-center space-x-3">
              <img src="/images/logo_icon.png" alt="otomochi" className="w-8 h-8 rounded-lg" />
              <span className="text-xl font-bold text-white">otomochi</span>
              <span className="text-white/60 text-sm hidden sm:inline">- TRPG書き起こしサービス</span>
            </div>

            {/* リンク */}
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-white/80">
              <button onClick={() => navigate('/guide')} className="hover:text-white transition-colors">機能ガイド</button>
              <button onClick={() => navigate('/pricing')} className="hover:text-white transition-colors">料金プラン</button>
              <button onClick={() => navigate('/faq')} className="hover:text-white transition-colors">FAQ</button>
              <button onClick={() => navigate('/contact')} className="hover:text-white transition-colors">お問い合わせ</button>
              <button onClick={() => navigate('/terms-simple')} className="hover:text-white transition-colors">かんたんな説明</button>
              <button onClick={() => navigate('/terms')} className="hover:text-white transition-colors">利用規約</button>
              <button onClick={() => navigate('/privacy')} className="hover:text-white transition-colors">プライバシー</button>
              <button onClick={() => navigate('/commerce')} className="hover:text-white transition-colors">特商法表記</button>
            </div>

            {/* SNS・コピーライト */}
            <div className="flex items-center space-x-4">
              <a
                href="https://twitter.com/otomochi_com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors"
                title="X (Twitter)"
              >
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href="https://discord.gg/hGckF2bnfM"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-lg flex items-center justify-center transition-colors"
                title="Discord"
              >
                <svg className="w-4 h-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                </svg>
              </a>
              <span className="text-white/50 text-xs hidden sm:inline">v1.0.0</span>
            </div>
          </div>

          <div className="mt-4 pt-4 border-t border-white/20 text-center text-white/50 text-xs">
            &copy; {new Date().getFullYear()} otomochi. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
